import React, { useRef, useState } from 'react'
import { IUnit, IWarehouse } from 'safe'
import Empty from '../../components/Display/Empty'
import EmptyBox from '../../assets/animations/empty_box.json'
import Button from '../../components/General/Button'
import { FiTrash2 } from 'react-icons/fi'
import FieldArrayAutocomplete from '../../components/Inputs/FieldArrayAutocomplete'
import { formatAmount } from '../../utils/utils'
import InputCheck from '../../components/Inputs/InputCheck'
// import useSnackBars from '../../hooks/SnackbarConsumerHook'

const LoadForm: React.FC<LoadFormProps> = ({
  onClose,
  onLoad,
  selectedLocation,
}) => {
  // const { addAlert } = useSnackBars()

  console.log('Selected location', selectedLocation)

  const [mockItemsLoaded, setMockItemsLoaded] = useState<ItemsLoaded[]>([])

  const refDivScroll = useRef<HTMLDivElement | null>(null)

  const [accounting, setAccounting] = useState<boolean>(true)

  const deleteItemFromLoad = (id) => {
    setMockItemsLoaded((state) => state.filter((item) => item.idItem != id))
  }

  const addItemToLoad = ({ value, amount, type }) => {
    console.log('value', type)
    // const newRow = {
    //   idItem: value.id,
    //   name: value.name,
    //   unit: value.unit,
    //   amount,
    // }
    refDivScroll.current?.scrollTo(0, 0)
    setMockItemsLoaded((state) => [
      ...state,
      { idItem: value.id, name: value.name, amount, type },
    ])
  }

  const loadInventory = () => {
    // console.log(mockItemsLoaded)
    if (mockItemsLoaded.length > 0) onLoad(mockItemsLoaded, accounting)
  }

  return (
    <div>
      <h1 className="mb-3">Carga de Artículos</h1>
      <div className="max-h-80 overflow-y-auto" ref={refDivScroll}>
        {mockItemsLoaded.length > 0 &&
          mockItemsLoaded.map((item) => (
            <div
              className="bg-gray-100 dark:bg-gray-800 rounded-lg my-4 p-2 flex justify-between items-center"
              key={item.idItem}
            >
              <div className="truncate">
                <h1 className="text-sm ml-3">{item.name}</h1>
                <h1 className="text-sm ml-3">
                  {item.amount}
                  {/* {formatAmount(item.amount, item.unit)} */}
                </h1>
              </div>

              <Button
                classes="border-none"
                onClick={() => deleteItemFromLoad(item.idItem)}
              >
                <FiTrash2 size={20} color="red" />
              </Button>
            </div>
          ))}
      </div>

      {mockItemsLoaded.length === 0 && (
        <Empty
          animationProps={{
            height: 200,
            width: 200,
            animation: EmptyBox,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Agrega artículos para cargarlos a su existencia
          </p>
        </Empty>
      )}
      <div className="my-3">
        <InputCheck
          label="Generar asiento contable"
          value={accounting}
          helperFunction={(value) => setAccounting(value)}
        />
      </div>
      <div className="grid grid-cols-12 gap-x-6 gap-y-2">
        <FieldArrayAutocomplete
          url={
            selectedLocation.warehouseType === 'PRODUCTION'
              ? `inventory/item/production`
              : `inventory/item/simple-search`
          }
          bodyGet={
            selectedLocation.warehouseType === 'PRODUCTION'
              ? `productionItems`
              : `items`
          }
          queryParam="param"
          valuesToCompare={mockItemsLoaded}
          onChangeValue={addItemToLoad}
          useCase="LOAD"
        />
      </div>
      <div className="flex space-x-2 mt-3 px-1 block">
        {onClose && (
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>
        )}
        <Button
          type="primary"
          classes={`w-1/2 mr-4 ${
            mockItemsLoaded.length === 0 && 'opacity-20 cursor-default'
          }`}
          htmlType="button"
          onClick={loadInventory}
        >
          Cargar Inventario
        </Button>
      </div>
    </div>
  )
}

interface LoadFormProps {
  onClose: Function
  onLoad: Function
  selectedLocation: any
}

interface ItemsLoaded {
  idItem: string
  name: string
  amount: number
}

export default LoadForm
